<form [formGroup]="equipmentForm">
    <app-picklist
        *ngIf="line"
        [formControl]="equipmentForm.controls['equipment']"
        [showValidations]="showValidations"
        [source]="availableEquipment"
        formControlName="equipment"
        sourceHeader="{{'admin.lines.create-modal.equipment.pick-list.leftHeader' | translate}}"
        targetHeader="{{'admin.lines.create-modal.equipment.pick-list.rightHeader' | translate}}"
        infoLabel="{{'admin.lines.create-modal.equipment.alert.message' | translate}}">
    </app-picklist>
</form>